import { Search } from "lucide-react";

export default function AtlasSearchInput({
  value = "",
  onChange,
  placeholder = "Search...",
  className = "",
  widthClass = "w-56",
}) {
  return (
    <div className={`relative ${widthClass} ${className}`}>
      <Search
        className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground"
        aria-hidden
      />
      <input
        type="search"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        className="w-full rounded-xl border border-gray-400 bg-card py-1.5 pl-8 pr-3 text-sm text-foreground placeholder:text-muted-foreground focus:border-sidebar-active focus:outline-none focus:ring-2 focus:ring-sidebar-active/20"
      />
    </div>
  );
}
